import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import configCard from '../configuration-scheme/config-card.vue';
import { fetchAppInfo, updateAppInfo } from '@/api/system/app';
import { getReviewInfo } from '@/api/creative/review';

export default {
  components: {
    configCard: configCard
  },
  props: {
    appId: {
      type: Number,
      required: true
    },
    appUrl: {
      type: String,
      required: true
    },
    platform: {
      type: String,
      required: true
    },
    demand: {
      type: Object,
      default: function _default() {}
    },
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    materialType: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      formValue: {
        id: '',
        app_url: '',
        platform: '',
        app_cat_ids: '',
        app_icon: '',
        custom_cat_name: ''
      },
      reviewInfo: '',
      formItemList: [],
      formLoading: true,
      formDisabled: false
    };
  },

  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate();
    },
    fillAppInfo: function fillAppInfo(info) {
      var appIconItem = this.formItemList.find(function (e) {
        return e.prop === 'app_icon';
      });
      var appCategoryItem = this.formItemList.find(function (e) {
        return e.prop === 'app_cat_ids';
      });
      if (info) {
        this.formValue.id = info.id;
        if (info.custom_cid) {
          this.formValue.app_cat_ids = info.custom_cid;
          if (appCategoryItem) {
            appCategoryItem.params.disabled = true;
          }
          this.formValue.custom_cat_name = info.custom_cat_name;
        } else {
          this.formValue.app_cat_ids = '';
          if (appCategoryItem) {
            appCategoryItem.params.disabled = false;
          }
          this.formValue.custom_cat_name = '-';
        }
        if (info.tag_names) {
          this.appTagName = info.tag_names;
        }
        if (info.app_icon) {
          this.formValue.app_icon = info.app_icon;
          appIconItem.params.fileList = [{
            url: info.app_icon,
            name: 'name'
          }];
          appIconItem.params.disabled = true;
        } else if (this.demand && this.demand.material_source === 3 && !info.app_icon) {
          // 素材来源为ss,无法获取app 图片地址
          this.formValue.app_icon = this.reviewInfo.app_icon;
          appIconItem.params.fileList = [{
            url: this.reviewInfo.app_icon,
            name: 'name'
          }];
          appIconItem.params.disabled = false;
        } else {
          appIconItem.params.fileList = [];
          appIconItem.params.disabled = false;
        }
        // this.formDisabled的值说明该app info是否需要提交，如果为true则提交表单的时候会触发saveAppInfo的方法
        if (info.custom_cid && info.app_icon) {
          this.formDisabled = true;
        } else {
          this.formDisabled = false;
        }
      } else {
        this.formValue.id = '';
        this.formValue.app_cat_ids = '';
        this.formValue.app_icon = '';
        appIconItem.params.fileList = [];
        appCategoryItem.params.disabled = false;
        appIconItem.params.disabled = false;
        this.formDisabled = false;
      }
    },
    fillFormItemList: function fillFormItemList() {
      var list = [{
        label: '产品链接：',
        type: 'link',
        prop: 'app_url',
        params: {
          target: '_blank'
        }
      }, {
        label: '投放平台：',
        type: 'plain-text',
        prop: 'platform'
      }, {
        label: '产品分类：',
        type: 'plain-text',
        prop: 'custom_cat_name'
      }, {
        label: '产品分类：',
        type: 'business',
        subtype: 'app-category-selector',
        prop: 'app_cat_ids',
        rules: [{
          required: true,
          message: '请至少选择产品分类',
          trigger: 'change'
        }],
        params: {
          disabled: false,
          clearable: true,
          placeholder: '请选择app分类标签'
        }
      }, {
        label: '产品icon：',
        type: 'business',
        subtype: 'single-image-uploader',
        prop: 'app_icon',
        rules: [{
          required: true,
          message: '请选择上传产品icon',
          trigger: 'blur'
        }],
        params: {
          disabled: false,
          'with-credentials': true,
          class: 'upload-demo',
          'list-type': 'picture-card',
          accept: 'image/*',
          tip: '只能上传jpg/png文件',
          fileList: []
        }
      }];
      var propKey = ['app_url', 'platform', 'app_cat_ids', 'app_icon'];
      if (this.readOnly) {
        propKey = ['app_url', 'platform', 'custom_cat_name', 'app_icon'];
      }
      return _.filter(list, function (e) {
        return propKey.indexOf(e.prop) !== -1;
      });
    },
    getAppInfoByUrl: function getAppInfoByUrl() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, cId, cType, getAppInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formValue.app_url = _this.appUrl;
                _this.formValue.platform = _this.platform;
                _this.formLoading = true;

                // 素材来源为ss

                if (!(_this.demand && _this.demand.material_source === 3 && !_this.readOnly)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 6;
                return getReviewInfo(_this.demand.source_object_id);

              case 6:
                res = _context.sent;

                _this.reviewInfo = JSON.parse(_.get(res, 'data.data.info.ext_info') || '""');
                cId = '';
                cType = _.get(res, 'data.data.info.creative_type') || '';

                if (cType === 3) {
                  cId = 2;
                } else if (cType === 4) {
                  cId = 3;
                } else if (cType === 5) {
                  cId = 1;
                } else if (cType === 6) {
                  cId = 4;
                } else if (cType === 7) {
                  cId = 5;
                }
                // eslint-disable-next-line vue/no-mutating-props
                _this.schemeValue.category_id = cId;

              case 12:
                getAppInfo = function getAppInfo() {
                  fetchAppInfo({
                    id: _this.appId,
                    material_type: _this.materialType
                  }).then(function (res) {
                    _this.formLoading = false;
                    if (res.data.data && res.data.data.info) {
                      _this.fillAppInfo(res.data.data.info);
                    } else {
                      _this.fillAppInfo(null);
                    }
                  }).catch(function () {
                    _this.formLoading = false;
                    _this.fillAppInfo(null);
                  });
                };

                getAppInfo();

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveAppInfo: function saveAppInfo() {
      var appIconItem = this.formItemList.find(function (e) {
        return e.prop === 'app_icon';
      });
      var appCategoryItem = this.formItemList.find(function (e) {
        return e.prop === 'app_cat_ids';
      });
      var postData = {
        id: this.formValue.id,
        custom_cid: this.formValue.app_cat_ids,
        icon_file: this.formValue.app_icon
        // 如果通过接口可以获取到app icon则不传app_icon
      };if (appIconItem.params.disabled) {
        postData = _.omit(postData, ['icon_file']);
      }
      // 如果通过接口可以获取到custom_cid则不传app_icon
      if (appCategoryItem.params.disabled) {
        postData = _.omit(postData, ['custom_cid']);
      }
      return updateAppInfo(postData);
    },
    disabledForm: function disabledForm() {
      this.formItemList.forEach(function (e) {
        if (e.params) {
          e.params.disabled = true;
        }
      });
    }
  },
  computed: {},
  watch: {
    'formValue.app_cat_ids': function formValueApp_cat_ids(val) {
      if (val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.schemeValue.app_cat_ids = val;
      }
    }
  },
  mounted: function mounted() {
    this.formItemList = this.fillFormItemList();
    if (this.readOnly) {
      this.disabledForm();
    }
  }
};